export const getCountryAwardJudgingKey = (awardId: number, countryId: number): string => `${awardId}:${countryId}`;
